import { useAppSelector } from '../../redux/_reduxHooks'
import { BuyNowButton } from './BuyNowButton'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useGetMinPrice } from '../../hooks/useGetMinPrices'

export const EventHeader = () => {
  const webEventTopicData = useAppSelector((state) => state.web.selectedNwTopic)

  const currentURL = window.location.href
  const currentURLbase = window.location.origin

  const { price, mwStSatz } = useGetMinPrice(webEventTopicData?.seminarList)

  // Prüfen ob Event neu (<= 9 Monaten angelegt) ist, um Badge anzuzeigen
  const isNewEvent = (dateString: string | null | undefined) => {
    if (dateString) {
      dayjs.extend(customParseFormat)

      const erfassungsdatum = dayjs('30.06.2023', 'DD.MM.YYYY', 'de')
      const nineMonthsAgo = dayjs().subtract(9, 'month')

      // Check if erfassungsdatum is after or the same as nineMonthsAgo
      return erfassungsdatum.isAfter(nineMonthsAgo) || erfassungsdatum.isSame(nineMonthsAgo)
    }
  }

  // URL encoding, also for special chars
  function fixedEncodeURIComponent(str: string) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16)
    })
  }

  const themenbereichUrl =
    '/seminare/suchen.aspx?search=null&datumVon=null&datumBis=null&themenKomplex=' +
    fixedEncodeURIComponent(webEventTopicData?.thmkplx ?? '').replace(/%20/g, '+') +
    '&seminarOrt=null&bl=null&g=null&tf='

  const taxText = mwStSatz === -1 ? 'Ust.-befreit' : `inkl. ${mwStSatz}% Ust.`

  return (
    <div className="container-fluid bg4s">
      <div className="row">
        <div className="container">
          <div className="padt-1"></div>
          <div className="row bgwhi" style={{ marginBottom: '0xp', borderTopLeftRadius: '0.6em', borderTopRightRadius: '0.6em' }}>
            <div className="col-xs-12">
              <div className="border001">
                <div className="col-md-12 text-left">
                  <div className="trenna"></div>
                  <div className="row">
                    <div className="col-xs-12 col-md-8 semdetailk">
                      <div className="row">
                        <div className="hidden-xs padt-1"></div>
                        <div className="col-sm-3" style={{ marginLeft: '10px' }}>
                          <span className="text-uppercase" style={{ marginRight: '5px' }}>
                            <b>Code</b>
                          </span>
                          <span className="">
                            <a className="detailsurl" href={webEventTopicData?.seminarLink}>
                              {webEventTopicData?.thmCode}
                            </a>
                          </span>
                        </div>
                        <div className="col-xs-12 col-md-10 tkomplex " style={{ marginLeft: '10px' }}>
                          <div className="hidden-xs padt-1"></div>
                          <small>
                            Themenbereich:
                            <a href={themenbereichUrl}>{webEventTopicData?.thmkplx}</a>
                          </small>
                        </div>
                        <div style={{ marginLeft: '10px' }} className="col-xs-12 col-md-10 padt-1">
                          <div className="visible-sm visible-xs" style={{ marginTop: '-30px' }}></div>
                          <h1 style={{ fontWeight: 'bold', fontSize: '30px', paddingBottom: '0' }}>
                            {webEventTopicData?.thmKurz}
                            {isNewEvent(webEventTopicData?.erfassungsdatum) && (
                              <span className="label label-info" style={{ borderRadius: '5px', fontSize: '12px', marginLeft: '5px' }}>
                                NEU
                              </span>
                            )}
                          </h1>
                          <div className="visible-sm visible-xs" style={{ marginTop: '-10px' }}></div>
                          <div style={{ marginTop: '20px' }}>{webEventTopicData?.thmLang}</div>
                          <div className="visible-md visible-lg" style={{ paddingBottom: '40px', marginBottom: '20px' }}></div>
                        </div>
                        <div className="hidden-xs col-xs-12 col-md-10 " style={{ marginLeft: '10px' }}>
                          <div className="col-xs-12">
                            <div className="hidden-xs hidden-sm">
                              <div className="row">
                                <form method="post">
                                  <button type="submit" name="#Socialpdf" data-toggle="tooltip" value={webEventTopicData?.thmCode} title="PDF-Download" className="pdfva">
                                    <i className="fa fa-print fa-fw"></i> <span>&nbsp;Druckversion</span>
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div className="col-xs-12">
                            <div className="hidden-xs hidden-sm">
                              <div className="row">
                                <form method="post">
                                  <div className="">
                                    <button
                                      type="submit"
                                      name="#Vormerk"
                                      data-toggle="tooltip"
                                      value={webEventTopicData?.thmCode}
                                      title={`Vormerken: ${webEventTopicData?.thmLang}`}
                                      className="pdfva "
                                    >
                                      <i className="fa fa-bookmark fa-fw"></i>
                                      <span className="liste">&nbsp; auf Favoritenliste setzen </span>
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-4 detailskopfrs">
                      <div className="row">
                        <div className="col-xs-12 padt-1"></div>
                        <div className="hidden-xs hidden-sm col-xs-12">
                          <div className="col-xs-12">
                            <div className="hidden-xs hidden-sm">
                              <div className="text-uppercase">
                                <div className="contsocial">
                                  <div className="sociald sociald2 row text-center">
                                    <div className="pdfb col-xs-1 col-sm-offset-6 col-md-offset-6">
                                      <div className="row">
                                        <form method="post">
                                          <button type="submit" name="#Socialpdf" data-toggle="tooltip" value={webEventTopicData?.thmCode} title="PDF-Download" className="pdfva">
                                            <i className="fa fa-print fa-fw"></i>
                                          </button>
                                        </form>
                                      </div>
                                    </div>

                                    <div className="col-xs-1 hidden-sm hidden-md hidden-lg">
                                      <a href={`https://wa.me/?text=Videoaufzeichnung%20-%20${currentURL}`} className="hidden-md hidden-sm hidden-lg whatsb">
                                        <i className="fa fa-whatsapp"></i>
                                      </a>
                                    </div>
                                    <div className="col-xs-1 hidden-xs">
                                      <a
                                        href={`mailto:?Subject=Videoaufzeichnung%20-%20${encodeURIComponent(currentURLbase)}&Body=${encodeURIComponent(
                                          `Diese Webseite des Kommunalen Bildungswerk e.V. empfehle ich - ${currentURL}`
                                        )}`}
                                        className="hidden-xs emailb"
                                        title="Als Email versenden"
                                        target="_blank"
                                      >
                                        <i className="fa fa-envelope"></i>
                                      </a>
                                    </div>
                                    <div className="col-xs-1 ">
                                      <a data-url={currentURL} href={`http://www.facebook.com/share.php?u=${currentURL}`} title="bei Facebook teilen" target="_blank" className="faceb">
                                        <i className="fa fa-facebook"></i>
                                      </a>
                                    </div>
                                    <div className="col-xs-1">
                                      <a
                                        data-url={currentURL}
                                        href={`http://twitter.com/share?url=/&amp;text=Videoaufzeichnung%20-%20${currentURL}`}
                                        title="bei Twitter twittern"
                                        target="_blank"
                                        className="twitterb"
                                      >
                                        <i className="fa fa-twitter"></i>
                                      </a>
                                    </div>

                                    <div className="col-xs-1">
                                      <a data-url={currentURL} href={`https://www.xing.com/social_plugins/share?url=${currentURL}`} title="bei Xing teilen" target="_blank" className="xingb">
                                        <i className="fa fa-xing"></i>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xs-12 padt-1"></div>
                          </div>
                        </div>
                        <div className="col-xs-12 col-md-11">
                          <div className="row panel">
                            <div className="">
                              <div className="row">
                                <div className="hidden-xs hidden-sm col-xs-12">
                                  <div className="panel-heading" style={{ paddingTop: '0px' }}>
                                    <div className="trenner"></div>
                                    <b>Angebot</b>
                                    <a className="pull-right small link1" href="/service/faqs">
                                      <i className="fa fa-question-circle-o fa-fw" aria-hidden="true"></i>Häufig gestellte Fragen
                                    </a>
                                  </div>
                                </div>
                                <div className="col-xs-12">
                                  <div className="col-xs-12">
                                    <div className="clearfix bg6 ">
                                      <div className="col-xs-4 small text-uppercase tkomplex">Typ</div>
                                      <div className=" col-xs-8 small">Videoaufzeichnung</div>
                                    </div>
                                    <div className="clearfix bg6">
                                      <div className="col-xs-4 small text-uppercase tkomplex">Orte</div>
                                      <div className=" col-xs-8 small">Online (Video)</div>
                                    </div>
                                    <div className="clearfix bg6">
                                      <div className="col-xs-4 small text-uppercase tkomplex">Format</div>
                                      <div className=" col-xs-8 small">Kaufen</div>
                                    </div>

                                    <div className="clearfix bg6">
                                      <div className="col-xs-4 small text-uppercase tkomplex">Preis ab</div>
                                      <div className=" col-xs-8">
                                        {price}

                                        <a className="pull-right small link1" href="/teilnahmebedingungen#tnge">
                                          <i>{taxText}</i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xs-12 hidden-xs"></div>
                              <div className="col-xs-12 bg2">
                                <div className="trenner1"></div>
                                <div className="row">
                                  <div className="col-xs-12">
                                    <div className="col-xs-12">
                                      <BuyNowButton style={{ marginBottom: '10px', width: '100%', borderRadius: '10px', fontSize: '16px' }} />
                                    </div>
                                  </div>
                                </div>
                                {webEventTopicData?.inhouseTopic && (
                                  <div className="row">
                                    <div className="hidden-xs col-xs-12">
                                      <div className="col-xs-12">
                                        <a href={`../inhouse/${webEventTopicData?.thmCode}`} rel="nofollow" title="Anfrageformular für eine Inhouseschulung öffnen.">
                                          <div className="btn-default btn btn-md btn-r btn-block btn-mehrz">
                                            <i className="fa fa-fw fa-magic hidden"></i>
                                            Inhouse Schulung anfragen
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 padt-1 hidden-xs"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
